import type { ContentOf } from '@shared/schemas/exercise'

/**
 * Speaking and conversation exercises need speech-to-text and the AI tutor,
 * which are Phase 3. Rather than fake a score, the player shows what the
 * exercise will ask and lets her move on — an honest placeholder beats a
 * broken feature, and beats pretending the exercise does not exist.
 */
export function DeferredExercise({
  content,
}: {
  content: ContentOf<'speaking'> | ContentOf<'conversation'>
}) {
  return (
    <div className="space-y-3 rounded-xl bg-sand-100 px-4 py-5">
      {content.type === 'speaking' ? (
        <>
          <p className="text-sm font-medium text-ink-700">You will say:</p>
          <p className="text-xl text-ink-900" lang="pt-BR">
            {content.expectedText}
          </p>
        </>
      ) : (
        <p className="text-sm font-medium text-ink-700">
          A guided conversation{content.turnGoal ? `: ${content.turnGoal}` : ''}.
        </p>
      )}
      <p className="text-sm text-ink-500">
        Speaking practice unlocks when the voice features land. This one is skipped for now.
      </p>
    </div>
  )
}
